import React from "react";
import CustomInput from "./CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Scrollbar from "react-scrollbars-custom";
export default ({ formik }) => {
  const deleteReason = (ind) => {
    const addOptions = (formik.values.addOptions || []).splice(ind, 1);
    formik.setFieldValue({ ...formik.values, addOptions });
  };
  return (
    <>
      <label className="poll-form-label">Responses</label>
      <Scrollbar>
        {(formik?.values?.addOptions).map((item, index) => (
          <React.Fragment key={index}>
            <CustomInput
              id={item.fieldName}
              formGroup={true}
              inputProps={{
                type: "text",
                name: item.fieldName,
                placeholder: item.label,
                ...formik.getFieldProps(
                  `addOptions.${index}.${item.fieldName}`
                ),
                error:
                  !!formik?.errors?.addOptions?.[index]?.response &&
                  !!formik?.errors?.addOptions?.[index]?.response &&
                  formik?.errors?.addOptions?.[index]?.response
                    ? formik?.errors?.addOptions?.[index]?.response
                    : "",
              }}
              inputClass="border-radius"
              style={{ padding: "2px", marginBottom: "-10px" }}
              endIcon={
                index > 1 ? (
                  <FontAwesomeIcon
                    onClick={() => deleteReason(index)}
                    style={{ marginLeft: "-30px", cursor: "pointer" }}
                    icon={faTrashAlt}
                    id="togglePassword"
                  />
                ) : null
              }
              keyValue={index + 1}
            />
          </React.Fragment>
        ))}
      </Scrollbar>
    </>
  );
};
